import { GuidedSellingExternalState_Choices } from "./state";
import { ExpandedRichText } from "@swo/shared";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { GuidedSellingStepIconChoice } from "@swo/storefront";
import { pipe } from "fp-ts/lib/function";
import { array, option } from "fp-ts";

export const getHintText = (s: GuidedSellingExternalState_Choices): string | ExpandedRichText | undefined => {
  const selectedId = s.data.selected;

  if (selectedId) {
    const values: NonEmptyArray<GuidedSellingStepIconChoice> = s.data.currentStep.choices;

    return pipe(
      values,
      array.findFirst(c => c.id === selectedId),
      option.chain(c => {
        return option.fromNullable<string | ExpandedRichText | undefined>(c.additionalInformation);
      }),
      option.toUndefined,
    );
  }

  return undefined;
};
